module.exports = __webpack_public_path__ + "img/0a465117154b4cd38b465bd5159000b6-1024.6f677395.jpg";